/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnListHelperService} from '../common/controller/list-helper.service';
import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './creative-retail-product-modal.component.html';
import {OBJECT_TYPE} from '../common/constants/object-type';
import {LocalNetworkInfo} from '../../components/session/local-network-info';
import {ProductFeedResource} from '../../components/api/resources/resource/product-feed.resource';
import {deferMarkForCheck} from '../common/util/defer-mark-for-check';

@Component({
  standalone: false,
  selector: 'adn-creative-retail-product-modal',
  template
})
export class CreativeRetailProductModalComponent implements OnInit {
  /** Set via BsModalService initialState */
  selRetailProduct: any;
  onSelect: (product: any) => Promise<any> | any;

  list: any = {};
  createHook: (product: any) => void;
  disabled = false;

  constructor(
    public bsModalRef: BsModalRef,
    private readonly adnListHelper: AdnListHelperService,
    private readonly cdr: ChangeDetectorRef,
    @Inject(ProductFeedResource) private readonly ProductFeed: any,
  ) {
  }

  ngOnInit(): void {
    const retailProductFields = [{label: 'name', param: 'itemTitle'}, 'brand', {param: '', label: 'image'}, 'price'];
    this.list.defaultFields = retailProductFields;
    this.list.sel = {selFields: this.list.defaultFields};
    this.list.merchantGuide = LocalNetworkInfo.obtain().getMerchantGuide();
    this.adnListHelper.setUpList(
      this.list,
      this.ProductFeed,
      true,
      'full' + OBJECT_TYPE.ProductFeed.type + 'List',
      {baseTable: OBJECT_TYPE.ProductFeed.apiParam, paginate: false}
    );

    this.createHook = (product: any) => {
      if (!_.isFunction(this.onSelect) || this.disabled) {
        return;
      }
      this.disabled = true;
      Promise.resolve(this.onSelect(product)).then(() => {
        this.bsModalRef.hide();
      }).catch(() => undefined).finally(() => {
        // Avoid NG0100 on [class.disabled] when select settles in the same CD turn.
        deferMarkForCheck(this.cdr, () => {
          this.disabled = false;
        });
      });
    };
  }

  dismiss(): void {
    if (!this.disabled) {
      this.bsModalRef.hide();
    }
  }
}
